import { Button, Col, Form, Input, Row } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Warning, Success } from "../../../commons/Messages/Messages";
import NormalUserLayout from "../../../layouts/NormalUserLayout/NormalUserLayout";
import { logoWhite } from "../../../commons/PanelImagepath";
import "../login/AuthPage.css";
import PasswordField from "../../../commons/PasswordField";
import { useTranslation } from "react-i18next";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";

const Register = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onSubmit = async data => {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/users/signup`, data)
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          history.push("/login");
        } else {
          Warning(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        Warning(err.response?.data?.errorMessage || err.message);
      });
  };

  useEffect(() => {
    document.body.classList.add("account-page");

    return () => document.body.classList.remove("account-page");
  }, []);

  return (
    <NormalUserLayout>
      <main className="auth-page">
        <div className="auth-page__card">
          <div className="auth-page__brand">
            <img src={logoWhite} alt="LeistFusion" />
          </div>
          <div className="auth-page__body">
            <h1 className="auth-page__title">{t("registeration")}</h1>
            <Form
              className="auth-page__form"
              size="large"
              name="basic"
              layout="vertical"
              onFinish={onSubmit}
              requiredMark={false}
            >
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="firstName"
                    label={t("forms.firstName")}
                    rules={[
                      {
                        required: true,
                        message: t("forms.requiredText", { field: t("firstname") })
                      }
                    ]}
                  >
                    <Input autoComplete="given-name" autoCapitalize="words" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="lastName"
                    label={t("forms.lastName")}
                    rules={[
                      {
                        required: true,
                        message: t("forms.requiredText", { field: t("lastName") })
                      }
                    ]}
                  >
                    <Input autoComplete="family-name" autoCapitalize="words" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name="username"
                label={t("forms.username")}
                rules={[
                  {
                    required: true,
                    message: t("forms.requiredText", { field: t("username") })
                  }
                ]}
              >
                <Input
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                />
              </Form.Item>
              <Form.Item
                name="email"
                label={t("forms.email")}
                rules={[
                  {
                    required: true,
                    message: t("forms.requiredText", { field: t("email") })
                  },
                  {
                    type: "email",
                    message: t("Please enter a valid email address!")
                  }
                ]}
              >
                <Input
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                />
              </Form.Item>
              <PasswordField label={t("Password")} name="password" />
              <Form.Item
                name="confirm"
                label={t("forms.confirmPassword")}
                dependencies={["password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: t("forms.confirmPasswordText")
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t("forms.passwordsDontMatch")));
                    }
                  })
                ]}
              >
                <Input.Password autoComplete="new-password" />
              </Form.Item>
              <Form.Item className="auth-page__submit">
                <Button type="primary" htmlType="submit" block loading={loading}>
                  {t("submit")}
                </Button>
              </Form.Item>
            </Form>
            <div className="auth-page__switch">
              <Link to="/login">{t("alreadyHaveAnAccount")}</Link>
            </div>
          </div>
        </div>
      </main>
    </NormalUserLayout>
  );
};

export default Register;
